import * as  numeral from 'numeral'

const trillion = 1000000000000
const billion = 1000000000
const million = 1000000
const hundredthousand = 100000
const thousand = 1000

const Formatter = {
    toCurrency: (value, symbol) => {
        return numeral(value).format(`$0,0.00`)
    },
    toCurrencyTrim: (value, symbol) => {
      value = value || 0
      let abs = Math.abs(value)
      if (abs >= million) {
          return numeral(value).format(`$0,0[.][000]am`)
      } else {
          return numeral(value).format(`$0,0`)
      }
    },
    toDecimal: (value) => {
        value = value || 0
        let abs = Math.abs(value)
        if (abs >= million) {
            return numeral(value).format(`0,0[.][000]am`)
        } else {
            return numeral(value).format(`0,0[.][0000000000000000]`)
        }
    },
    toDecimalTrim: (value) => {
        value = value || 0
        let abs = Math.abs(value)
        if (abs >= million) {
            return numeral(value).format(`0,0[.][000]am`)
        } if (abs >= thousand) {
            return numeral(value).format(`0,0`)
        } else {
            return numeral(value).format(`0,0[.][000]`)
        }
    },
    toDecimalTrim9: (value) => {
        value = value || 0
        let abs = Math.abs(value)
        if (abs >= million) {
            return numeral(value).format(`0,0[.][000]am`)
        } else if (abs >= hundredthousand) {
            return numeral(value).format(`0,0`)
        } else if (abs >= 10000) {
            return numeral(value).format(`0,0[.][0000]`)
        } else if (abs >= 1000) {
            return numeral(value).format(`0,0[.][00000]`)
        } else if (abs >= 100) {
            return numeral(value).format(`0,0[.][000000]`)
        } else if (abs >= 10) {
            return numeral(value).format(`0,0[.][0000000]`)
        } else {
          const parsedNumber = numeral(value).format(`0,0[.][00000000]`)
          return (parsedNumber == 'NaN') ? '0.00000001' : parsedNumber
          //return numeral(value).format(`0,0[.][00000000]`)
        }
    },
    roundUp:(num, precision)=>{
        precision = Math.pow(10, precision);
        return Math.round(num * precision) / precision;
    }
}
export default {
    Formatter
}
